import { Component } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { Message } from 'primeng/api'

import { AuthService } from '@data/services/modules/auth/auth.service'
import { resolveLandingRoute } from '@data/constants/role-landing-route.constant'

/**
 * Pantalla bloqueante de cambio de contraseña obligatorio en primer ingreso
 * (ADR-0014, extendido a usuarios internos). Solo se llega aquí desde el AuthGuard
 * cuando `authService.mustChangePassword` es true. La única salida es completar el
 * cambio (POST /auth/change-password) o cerrar sesión.
 */
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {
  entity: FormGroup
  showMessage = false
  responseMessage: Message[] = []
  submitting = false

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.entity = this.fb.group({
      currentPassword: ['', [Validators.required]],
      // Mismas reglas que el backend (min 8, mayúscula, minúscula, número, especial).
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.,\-;:_<>{}\[\]+/*])[A-Za-z\d@$!%*?&.,\-;:_<>{}\[\]+/*]+$/)]],
      confirmPassword: ['', [Validators.required]]
    })
  }

  submit() {
    this.showMessage = false
    this.responseMessage = []

    const { currentPassword, newPassword, confirmPassword } = this.entity.value

    if (newPassword !== confirmPassword) {
      this.fail('La nueva contraseña y la confirmación no coinciden.')
      return
    }
    if (newPassword === currentPassword) {
      this.fail('La nueva contraseña debe ser distinta a la temporal.')
      return
    }

    this.submitting = true
    this.authService.changePassword(currentPassword, newPassword).subscribe((r) => {
      this.submitting = false
      if (r.error) {
        this.fail(r.msg || 'No se pudo actualizar la contraseña.')
        return
      }
      this.authService.clearMustChangePassword()
      const roleName = this.authService.getUser?.user?.permissions?.name
      this.router.navigate([resolveLandingRoute(roleName)])
    })
  }

  logout() {
    this.authService.logout()
    this.router.navigate(['/login'])
  }

  private fail(msg: string) {
    this.responseMessage = [{ summary: msg, severity: 'error', closable: true }]
  }
}
